import { TextInput } from '@framework/form/inputs/TextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { useMemo } from 'react';
import { useTreeReferencesContext } from '../../../../../tree/references/TreeReferencesContext.tsx';
import { ReferenceType } from '../../../../expressions/references/IReference.ts';
import { resolveTreeReferences } from '../../../../expressions/references/resolve/resolveTreeReferences.ts';
import { AlignmentSelectInput } from '../../common/AlignmentSelectInput.tsx';
import { ButtonTypeSelectInput } from '../../common/ButtonTypeSelectInput.tsx';
import { IconTypeSelectInput } from '../../common/IconTypeSelectInput.tsx';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm.tsx';
import { IconType } from '../buttons/icons/Icons.tsx';
import { ButtonType } from '../buttons/types/ButtonEnums.ts';

export function ConfirmWidgetConfigComponent() {
  const { widget, root } = useTreeReferencesContext();

  const connectableWidgets = useMemo(() => {
    if (!root || !widget) return [];

    return resolveTreeReferences(root, widget).filter(
      r => r.type === ReferenceType.Widget,
    );
  }, [root, widget]);

  return (
    <div>
      <CodeLabelInputForm hideLabel hideColSpan />
      <RowElement>
        <FormItem name="layout.confirmIcon" label="Icona pulsante conferma">
          <IconTypeSelectInput
            name="layout.confirmIcon"
            defaultValue={IconType.Nessuna}
          />
        </FormItem>
        <FormItem name="layout.confirmText" label="Testo pulsante conferma">
          <TextInput name="layout.confirmText" />
        </FormItem>
        <FormItem
          name="layout.confirmButtonType"
          label="Tipo pulsante conferma"
        >
          <ButtonTypeSelectInput
            name="layout.confirmButtonType"
            defaultValue={ButtonType.Primary}
          />
        </FormItem>
      </RowElement>
      <RowElement>
        <FormItem name="layout.editIcon" label="Icona pulsante modifica">
          <IconTypeSelectInput
            name="layout.editIcon"
            defaultValue={IconType.Nessuna}
          />
        </FormItem>
        <FormItem name="layout.editText" label="Testo pulsante modifica">
          <TextInput name="layout.editText" />
        </FormItem>
        <FormItem name="layout.editButtonType" label="Tipo pulsante modifica">
          <ButtonTypeSelectInput
            name="layout.editButtonType"
            defaultValue={ButtonType.Default}
          />
        </FormItem>
      </RowElement>
      <FormItem name="layout.buttonsAlign" label="Allineamento bottoni">
        <AlignmentSelectInput name="layout.buttonsAlign" />
      </FormItem>
    </div>
  );
}
